import { Box, Button, styled } from "@mui/material"
import { colors } from "../../../theme/colors"
import UIIcon from "../../../components/UIIcon"
import { WhiteCard } from "../../../components/styled"

export const ContentContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  width: "100%",
})

export const brandPayIcon = styled(UIIcon)({
  height: 27,
})

export const BankCard = styled(WhiteCard)({
  width: "100%",
  boxSizing: "border-box",
  margin: "30px 0",
  display: "flex",
  flexDirection: "column",
  paddingBottom: 10,
})

export const PaymentToolCard = styled(WhiteCard)({
  width: "100%",
  boxSizing: "border-box",
  margin: "30px 0",
  display: "flex",
  flexDirection: "column",
  paddingBottom: 10,
})

export const AmountsContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexWrap: "wrap",
  marginTop: 16,
})

export const BankButtons = styled(Box)({
  height: 64,
  display: "flex",
  alignItems: "flex-start",
  gap: 10,
  overflow: "auto",
})

export const BankButton = styled(Box, {
  shouldForwardProp: (props) => props !== "active",
})(({ active }: { active?: boolean }) => ({
  width: "fit-content",
  height: "fit-content",
  borderRadius: "40%",
  boxSizing: "border-box",
  border: "1px solid",
  borderColor: active ? colors.yellow : "transparent",
  padding: 3,
}))

export const ContinueButton = styled(Button)({
  marginTop: "auto",
})

export const ToolButton = styled(Box)({
  display: "flex",
  alignItems: "center",
})
